import { ParticipationDTO } from '../apis/api.participation'

export const TagList = ({ tags }: { tags?: ParticipationDTO['tags'] }) => {
    if (!tags) return null

    return (
        <div style={{ display: 'flex', gap: '5px' }}>
            {tags.map((tag) => {
                return (
                    <span
                        key={`${tag}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '1em',
                            padding: '3px 10px',
                            fontSize: '0.86em',
                            border: '1px solid',
                        }}
                    >
                        {tag}
                    </span>
                )
            })}
        </div>
    )
}
